/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const entitiesPageMessages = defineMessages({
    pageTitle: {
        id: 'luis.entitiesPage.pageTitle',
        defaultMessage: 'Entities'
    },
    pageTitleDescription: {
        id: 'luis.entitiesPage.pageTitleDescription',
        defaultMessage: 'An entity is used like a variable in algebra. It is used to capture and pass important information.'
    },
    renameModalTitle: {
        id: 'luis.entitiesPage.renameModalTitle',
        defaultMessage: 'Rename entity'
    },
    deleteEntityModalTitle: {
        id: 'luis.entitiesPage.deleteEntityModalTitle',
        defaultMessage: 'Delete entity/entities?'
    },
    deleteEntityModalDescription: {
        id: 'luis.entitiesPage.deleteEntitiesModalDescription',
        defaultMessage: 'Are you sure you want to delete the selected entity/entities?'
    },
    createEntityToastStart: {
        id: 'luis.intentsPage.createEntityToastStart',
        defaultMessage: 'Creating entity ...'
    },
    createEntityToastSuccess: {
        id: 'luis.intentsPage.createEntityToastSuccess',
        defaultMessage: 'Create entity completed'
    },
    createEntityToastFailed: {
        id: 'luis.intentsPage.createEntityToastFailed',
        defaultMessage: 'Create entity failed'
    },
    addEntityToastStart: {
        id: 'luis.intentsPage.addEntityToastStart',
        defaultMessage: 'Adding entity ...'
    },
    addEntityToastSuccess: {
        id: 'luis.intentsPage.addEntityToastSuccess',
        defaultMessage: 'Add entity completed'
    },
    addEntityToastFailed: {
        id: 'luis.intentsPage.addEntityToastFailed',
        defaultMessage: 'Add entity failed'
    },
    updateEntityToastStart: {
        id: 'luis.intentsPage.updateEntityToastStart',
        defaultMessage: 'Updating entity ...'
    },
    updateEntityToastSuccess: {
        id: 'luis.intentsPage.updateEntityToastSuccess',
        defaultMessage: 'Update entity completed'
    },
    updateEntityToastFailed: {
        id: 'luis.intentsPage.updateEntityToastFailed',
        defaultMessage: 'Update entity failed'
    },
    deleteEntityToastStart: {
        id: 'luis.intentsPage.deleteEntityToastStart',
        defaultMessage: 'Deleting entity ...'
    },
    deleteEntitiesToastStart: {
        id: 'luis.intentsPage.deleteEntitiesToastStart',
        defaultMessage: 'Deleting entities ...'
    },
    deleteEntityToastSuccess: {
        id: 'luis.intentsPage.deleteEntityToastSuccess',
        defaultMessage: 'Delete entity completed'
    },
    deleteEntitiesToastSuccess: {
        id: 'luis.intentsPage.deleteEntitiesToastSuccess',
        defaultMessage: 'Delete entities completed'
    },
    deleteEntityToastFailed: {
        id: 'luis.intentsPage.deleteEntityToastFailed',
        defaultMessage: 'Deleting entity failed'
    },
    deleteEntitiesToastFailed: {
        id: 'luis.intentsPage.deleteEntitiesToastFailed',
        defaultMessage: 'Deleting entities failed'
    },
    operationCompleted: {
        id: 'luis.intentsPage.operationCompleted',
        defaultMessage: 'Operation completed'
    },
    deletionOperationCompleted: {
        id: 'newEntityTable.newEntityTableMessages.deletionOperationCompleted',
        defaultMessage: 'Successfully deleted'
    },
    renamingOperationCompleted: {
        id: 'newEntityTable.newEntityTableMessages.renamingOperationCompleted',
        defaultMessage: 'Entity successfully renamed'
    },
    additionOperationCompleted: {
        id: 'newEntityTable.newEntityTableMessages.creationOperationCompleted',
        defaultMessage: 'Entity successfully added'
    }
});
